import {gql} from "@apollo/client";

const linkWithUniversityMutation = gql`
    mutation linkWithUniversityMutation(
        $countryId: String
        $degreesInterested: [String]
        $acceptMarketing: Boolean
        $universitySlug: String
        $degreeLevel: String
        $domesticRegion: String
        $dateOfEntry: Date
        $customAttributes: [CustomAttributeValueInput]
        $sourceTrackingParams: JSONString
        $localePreference: UserLocalePreferenceInput
    ) {
        updateMyUniversityLink(
            countryId: $countryId
            domesticRegion: $domesticRegion
            degreesInterested: $degreesInterested
            acceptMarketing: $acceptMarketing
            universitySlug: $universitySlug
            degreeLevel: $degreeLevel
            dateOfEntry: $dateOfEntry
            customAttributes: $customAttributes
            sourceTrackingParams: $sourceTrackingParams
            localePreference: $localePreference
        ) {
            me {
                anyUser {
                    id
                    country {
                        id
                        name
                    }
                    domesticRegion {
                        id
                        name
                    }
                }
                applicant {
                    id
                    applicantUniversities {
                        id
                        university {
                            id
                            slug
                        }
                        applied
                        setupComplete
                        hasAcceptedMarketing
                        dateOfEntry
                        degreeLevel {
                            id
                            name
                        }
                        degreesInterested {
                            id
                            name
                        }
                        delinked
                        customAttributes(active: true) {
                            value
                            attribute {
                                id
                                name
                                type
                            }
                            ... on SingleChoiceValueField {
                                option {
                                    id
                                    value
                                }
                            }
                            ... on OpenTextFieldValueField {
                                text
                            }
                            ... on DateValueField {
                                date
                            }
                        }
                    }
                    localePreference {
                        id
                        locale
                        name
                    }
                }
            }
        }
    }
`;

export default linkWithUniversityMutation;
